export default {"src":"/_next/static/media/carDetailBackImgArrow.90ce8736.svg","height":46,"width":32};